import {
  Tab as HeadlessTab,
  TabGroup as HeadlessTabGroup,
  TabList as HeadlessTabList,
} from "@headlessui/react";
import classNames from "classnames";
import { PropsWithChildren } from "react";
import styles from "./Tab.module.css";

type TabGroupProps = PropsWithChildren<{
  defaultIndex?: number;
  selectedIndex?: number;
  onChange?: (index: number) => void;
}>;

const TabGroup = (props: TabGroupProps) => {
  return <HeadlessTabGroup className={styles.group} {...props} />;
};

type TabListProps = PropsWithChildren<{ className?: string }>;

const TabList = ({ children, className }: TabListProps) => {
  if (!children) return null;

  return (
    <nav className={classNames(styles.nav, className)}>
      <HeadlessTabList className={styles.list}>{children}</HeadlessTabList>
    </nav>
  );
};

type TabProps = PropsWithChildren<{
  active?: boolean;
  disabled?: boolean;
  title?: string;
  className?: string;
}>;

const Tab = ({ children, title, active, className }: TabProps) => {
  return (
    <HeadlessTab
      title={title}
      className={({ selected }) => {
        return classNames(
          styles.link,
          {
            [styles.linkActive]: active ?? selected,
          },
          className,
        );
      }}
    >
      {children}
    </HeadlessTab>
  );
};

Tab.Group = TabGroup;
Tab.List = TabList;

export default Tab;
